import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../store';
import { fetchEvents, selectRequestStatus } from '../../reducers/eventsSlice';
import LoadingIndicator from '../common/LoadingIndicator';
import EventsList from '../project/EventsList';
import { useToken } from '../../hooks/useToken';
import { PageCenteredLayout } from '../layout/PageCenteredLayout';
import { useCurrentUser } from '../../hooks/useCurrentUser';

// Custom hook to detect if screen is below the lg breakpoint (1024px)
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024); // 1024px is the lg breakpoint in Tailwind
    };

    // Check on initial render
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile;
};

export default function EventDeploymentsPage() {
  const dispatch = useDispatch<AppDispatch>();
  const token = useToken();
  const { canPublish } = useCurrentUser();
  const isMobile = useIsMobile();
  const role = canPublish ? 'admin' : 'consumer';

  const dispatchEventUpdates = () => {
    if (token) {
      dispatch(fetchEvents({ token, role })).catch((error) => {
        console.error('Failed to load event:', error);
      });
    }
  };

  useEffect(() => {
    if (token) {
      dispatchEventUpdates();
    }
  }, [dispatch, token]);

  return (
    <PageCenteredLayout>
      {/* Only show the title when on mobile (sidebar is hidden) */}
      {isMobile && <h1 className="mb-12 text-3xl text-dataops-primary-dark-blue/40">Events</h1>}
      <LoadingIndicator selectRequestStatus={selectRequestStatus} />
      <EventsList />
    </PageCenteredLayout>
  );
}
